export const IMAGE_URL = "https://docs.vertex360.io/";


// export const BASE_URL = ENVIRONMENT_URL.LOCAL_BASE_URL;

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const AI_SERVICE_URL = process.env.REACT_APP_AI_SERVICE_URL;


export const REPORT_DOWNLOAD_URL = "cos/case-notes";
export const AH_REPORT_DOWNLOAD_URL = "ah/case-notes";

// Template file paths for import functionality
// These paths are relative to IMAGE_URL (https://docs.vertex360.io/)
export const PARTICIPANT_IMPORT_TEMPLATE_PATH = "import-example/participant-example/participant_import_template.xlsx";
export const WORKER_IMPORT_TEMPLATE_PATH = "import-example/worker-example/worker_import_template.xlsx";
export const URL_LOGIN = `${BASE_URL}login`;
export const URL_OTP = `${BASE_URL}send-otp`;
export const URL_CONFIRM_OTP = `${BASE_URL}confirm-otp`;
export const URL_RESEND_OTP = `${BASE_URL}resend-otp`;
export const URL_RESEND_EMAIL_VERFIICATION = `${BASE_URL}resend-email-verification-code`;
export const URL_GET_SLUG_FROM_URL = `${BASE_URL}branding`;
/** Public (no auth) — for WordPress / marketing landing at /feature-of-the-week */
export const URL_PUBLIC_FEATURE_OF_THE_WEEK = `${BASE_URL}feature-of-the-week`;

export const URL_LOGOUT = `${BASE_URL}logout`;

//---------------------------SUPER ADMIN --------------------------------//
export const URL_SUPER_ADMIN_CRM_FORM_CATEGORIES = `${BASE_URL}super-admin/form-categories`;
export const URL_SUPER_ADMIN_HRM_FORM_CATEGORIES = `${BASE_URL}super-admin/hrm/form-categories`;
export const URL_SUPER_ADMIN_CRM_FORM_TEMPLATES = `${BASE_URL}super-admin/form-templates-list`;
export const URL_SUPER_ADMIN_HRM_FORM_TEMPLATES = `${BASE_URL}super-admin/hrm/form-templates-list`;
export const URL_FORM_TEMPLATE_DRAFT_TO_PUBLISH = `${BASE_URL}super-admin/form-template/draft-publish`;
export const URL_FORM_TEMPLATE_DRAFT_TO_PUBLISH_SP = `${BASE_URL}sp/form-templates/draft-publish`;
export const URL_FORM_TEMPLATE_DRAFT_TO_PUBLISH_FOR_HRM = `${BASE_URL}super-admin/hrm/form-template/draft-publish`;
export const URL_PLATFORM_ADMIN_DASHBOARD_STATS = "super-admin/dashboard/stats";
export const URL_PLATFORM_ADMIN_SESSION = "super-admin/session";
export const URL_PLATFORM_ADMIN_BILLING_OVERVIEW = "super-admin/billing/overview";
export const URL_PLATFORM_ADMIN_BILLING_SYNC = "super-admin/billing/sync-invoices";
export const URL_PLATFORM_ADMIN_BILLING_STRIPE_CUSTOMERS = "super-admin/billing/stripe-customers";
export const URL_PLATFORM_ADMIN_BILLING_PLANS = "super-admin/billing/plans";
export const URL_PLATFORM_ADMIN_USAGE = "super-admin/usage";
export const URL_PLATFORM_ADMIN_USAGE_EXPORT = "super-admin/usage/export";
export const URL_PLATFORM_ADMIN_USAGE_REFRESH = "super-admin/usage/refresh";
export const URL_PLATFORM_ADMIN_AI_USAGE_OVERVIEW = "super-admin/ai-usage/overview";
export const URL_PLATFORM_ADMIN_AI_USAGE_TENANTS = "super-admin/ai-usage/tenants";
export const URL_PLATFORM_ADMIN_AI_USAGE_EXPORT = "super-admin/ai-usage/export";
export const URL_PLATFORM_ADMIN_AI_USAGE_REFRESH = "super-admin/ai-usage/refresh";
export const URL_PLATFORM_ADMIN_AUDIT_EXPORT = "super-admin/audit-log/export";
export const URL_PLATFORM_ADMIN_SALE_LEADS = "super-admin/sale-leads";
export const URL_PLATFORM_ADMIN_TENANTS = "super-admin/tenants";
export const URL_PLATFORM_ADMIN_USER_SEARCH = "super-admin/users/search";
export const URL_PLATFORM_ADMIN_SET_PASSWORD = "super-admin/user/set-password";
export const URL_PLATFORM_ADMIN_STAFF_USERS = "super-admin/staff-users";
export const URL_PLATFORM_ADMIN_AUDIT_LOG = "super-admin/audit-log";
export const URL_PLATFORM_ADMIN_ROLES_BASE = "super-admin/roles-and-permission";
export const URL_PLATFORM_ADMIN_ROLES = `${URL_PLATFORM_ADMIN_ROLES_BASE}/roles`;
export const URL_PLATFORM_ADMIN_ROLE_CREATE = `${URL_PLATFORM_ADMIN_ROLES_BASE}/role/create`;
export const URL_PLATFORM_ADMIN_ROLE_STORE = `${URL_PLATFORM_ADMIN_ROLES_BASE}/role/store`;
export const URL_PLATFORM_ADMIN_ROLE_UPDATE = `${URL_PLATFORM_ADMIN_ROLES_BASE}/role/update`;
export const URL_PLATFORM_ADMIN_GHOST_START = "super-admin/ghost/start";
export const URL_PLATFORM_ADMIN_GHOST_END = "super-admin/ghost/end";
export const URL_PLATFORM_ADMIN_GHOST_SESSIONS = "super-admin/ghost/sessions";
export const URL_PLATFORM_ADMIN_GHOST_FORCE_END = "super-admin/ghost";
export const URL_PLATFORM_ADMIN_USER_LOCK = "super-admin/users";
export const URL_PLATFORM_ADMIN_FEATURE_OF_THE_WEEK =
  "super-admin/feature-of-the-week";
export const URL_SP_FEATURE_OF_THE_WEEK = "sp/feature-of-the-week/show";
export const URL_PLATFORM_ADMIN_EVENTS = "super-admin/events";
export const URL_SP_EVENTS = "sp/events";
export const URL_FORM_TEMPLATE_DRAFT_TO_PUBLISH_FOR_HRM_SP = `${BASE_URL}sp/hrm/form-templates/draft-publish`;

export const URL_FORM_SEND_EMAIL_FOR_SP = `${BASE_URL}sp/form_data/send-emails`;
export const URL_FORM_SEND_EMAIL_FOR_WORKER = `${BASE_URL}hrm/form_data/send-emails`;
export const URL_SHOW_OR_HIDE_PT_FORM_TO_WORKER = `${BASE_URL}sp/show-or-hide-pt-form-to-worker`;

//--------------------------- SP ADMIN --------------------------------//

export const URL_SP_DASHBOARD = `${BASE_URL}sp/dashboard`;
export const URL_SP_SETTING = `${BASE_URL}sp/settings`;
export const URL_HRM_CREATE_FOLDER = `${BASE_URL}sp/folder/worker/store`;
export const URL_HRM_UPDATE_FOLDER = `${BASE_URL}sp/folder/worker/update`;
export const URL_HRM_REMOVE_FOLDER = `${BASE_URL}sp/folder/worker/delete`;
export const URL_HRM_FOLDER_LIST = `${BASE_URL}sp/folder/worker/show`;
export const URL_HRM_REMOVE_FILE = `${BASE_URL}sp/file-management/delete-file`;
export const URL_SP_DASHBOARD_INPROGRESS_SHIFTS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/upcoming-shifts`;

export const URL_PARTICIPANT_CREATE_FOLDER = `${BASE_URL}sp/folder/participant/store`;

export const URL_PARTICIPANT_UPDATE_FOLDER = `${BASE_URL}sp/folder/participant/update`;
export const URL_PARTICIPANT_MOVE_FOLDER = `${BASE_URL}sp/folder/participant/move`;
export const URL_SP_WORKER_MOVE_FOLDER = `${BASE_URL}sp/folder/worker/move`;
export const URL_HRM_WORKER_MOVE_FOLDER = `${BASE_URL}hrm/folder/worker/move`;
export const URL_PARTICIPANT_REMOVE_FOLDER = `${BASE_URL}sp/folder/participant/delete`;
export const URL_PARTICIPANT_FOLDER_LIST = `${BASE_URL}sp/folder/participant/show`;
export const URL_HRM_PARTICIPANT_FOLDER_LIST = `${BASE_URL}hrm/folder/participant/show`;
export const URL_PARTICIPANT_REMOVE_FILE = `${BASE_URL}sp/file-management/delete-file`;

export const URL_WORKER_FOLDER_LIST = `${BASE_URL}hrm/folder/worker/show`;
export const URL_WORKER_CREATE_FOLDER = `${BASE_URL}hrm/folder/worker/store`;
export const URL_WORKER_UPDATE_FOLDER = `${BASE_URL}hrm/folder/worker/update`;
export const URL_WORKER_REMOVE_FOLDER = `${BASE_URL}hrm/folder/worker/delete`;
export const URL_WORKER_REMOVE_FILE = `${BASE_URL}hrm/file-management/delete-file`;

export const URL_SP_PARTICIPANTS = `${BASE_URL}sp/participants-list`;
export const URL_SP_WORKER = `${BASE_URL}sp/participant-setting/worker-list`;
export const URL_SP_WORKER_FOR_BLACK_PORTAL = `${BASE_URL}worker/participant-setting/worker-list`;
export const URL_SP_FEEDBACK = `${BASE_URL}sp/feedback`;
export const URL_FEEDBACK_MANAGERS_LIST = `${BASE_URL}sp/feedback/manager_list`;
export const URL_FEEDBACK_PARTICIPANTS_LIST = `${BASE_URL}sp/feedback/participants_list`;
export const URL_FEEDBACK_WORKER_LIST = `${BASE_URL}sp/feedback/worker_list`;
export const URL_FEEDBACK_DELETE = `${BASE_URL}sp/feedback/delete`;
export const URL_WORKER_FEEDBACK_LIST = `${BASE_URL}hrm/feedback/list`;
export const URL_FEEDBACK_WORKER_LIST_FOR_BLACK_PORTAL = `${BASE_URL}hrm/feedback/workers`;
export const URL_FEEDBACK_MANAGERS_LIST_FOR_BLACK_PORTAL = `${BASE_URL}hrm/feedback/managers`;
export const URL_SP_COMPLAINT = `${BASE_URL}sp/complaint`;
export const URL_SP_QUESTION = `${BASE_URL}ask-question`;
export const URL_SP_FORM_CATEGGORES = `${BASE_URL}sp/form-categories`;
export const URL_SP_FORM_CATEGORIES_MANAGE = `${BASE_URL}sp/form-categories/manage`;
export const URL_SP_FORM_CATEGORIES_VISIBILITY = `${BASE_URL}sp/form-categories/visibility`;
export const URL_SP_CRM_FORM_TEMPLATES = `${BASE_URL}sp/form-templates`;
export const URL_SP_CRM_FORM_TEMPLATES_WITH_CATEGORIES = `${BASE_URL}sp/form-templates-with-categories`;
export const URL_SP_HRM_FORM_TEMPLATES = `${BASE_URL}sp/hrm/form-templates`;
export const URL_SP_DOCUMENTS = `${BASE_URL}sp/documents`;
export const URL_SP_DELETE_DOCUMENTS = `${BASE_URL}sp/delete-document`;
export const URL_SP_UPLOAD_DOCUMENTS = `${BASE_URL}sp/file-management/upload-document`;
export const URL_SP_EMPLOYEE_DOCUMENTS = `${BASE_URL}sp/worker-docs`;
export const URL_SP_UPDATE_DOCUMENTS = `${BASE_URL}sp/update-document`;
export const URL_SP_RISK_RATING_TAB_LIST = `${BASE_URL}sp/participant/submitted-forms`;
export const URL_SP_CREATE_MANAGER = `${BASE_URL}sp/register-manager`;
export const URL_SP_VALIDATE_FAMILY_MEMBER = "sp/validate-family-member";
export const URL_SP_REGISTER_FAMILY_MEMBER = "sp/register-family-member";
export const URL_SP_UNLINK_FAMILY_MEMBER = "sp/unlink-family-member";
export const URL_SP_UPDATE_FAMILY_MEMBER = "sp/update-family-member";
export const URL_SP_RESEND_FAMILY_APP_INVITE = "sp/resend-family-app-invite";
export const URL_FAMILY_SET_PASSWORD = "family-set-password";
export const URL_FAMILY_SET_PASSWORD_INFO = "family-set-password-info";
export const URL_SP_MANAGER_ROLE = `${BASE_URL}sp/update-managers-role`;
export const URL_SP_LIST_MANAGER = `${BASE_URL}sp/managers-list`;
export const URL_SP_PRIMARY_PORTAL_USER_LIST = `${BASE_URL}sp/primary-portal-users-list`;
export const URL_SP_INCIDENT_REPORTING_SETTING = `${BASE_URL}sp/incident-reporting-setting`;
export const URL_SP_SUBMITTED_FORMS_LIST = `${BASE_URL}sp/participant/submitted-forms`;
export const URL_SP_HRM_SUBMITTED_FORMS_LIST = `${BASE_URL}sp/employee/submitted-forms`;
export const URL_SP_POLICIES_DELETE = `${BASE_URL}sp/delete-policy`;
export const URL_SP_UPLOAD_DOCUMENT = `${BASE_URL}sp/upload-document`;

export const URL_SP_DELETE_CASE_NOTE_ATTACHMENT = `${BASE_URL}sp/case-note/attachment`;

// Staff Compliance
export const URL_SP_STAFF_COMPLIANCE_SETTING = `${BASE_URL}sp/worker-compliance-setting`;
export const URL_SP_STAFF_COMPLIANCE_SETTING_UPDATE = `${BASE_URL}sp/worker-compliance-setting/update`;
export const URL_SP_STAFF_COMPLIANCE_ADD_DOCUMENT = `${BASE_URL}sp/worker-compliance-setting/documents`;
export const URL_SP_STAFF_COMPLIANCE_CREATE_CATEGORY = `${BASE_URL}sp/worker-compliance-setting/categories`;
export const URL_SP_STAFF_COMPLIANCE_CATEGORY_VISIBILITY = (uuid) => `${BASE_URL}sp/worker-compliance-setting/categories/${uuid}`;
export const URL_SP_STAFF_COMPLIANCE_CATEGORY_UPDATE = (uuid) => `${BASE_URL}sp/worker-compliance-setting/categories/${uuid}`;
export const URL_SP_STAFF_COMPLIANCE_CATEGORY_DELETE = (uuid) => `${BASE_URL}sp/worker-compliance-setting/categories/${uuid}`;
export const URL_SP_STAFF_COMPLIANCE_DELETE_DOCUMENT = (uuid) => `${BASE_URL}sp/worker-compliance-setting/documents/${uuid}`;

// Participant Compliance
export const URL_SP_PARTICIPANT_COMPLIANCE_PROFILES = `${BASE_URL}sp/participant-compliance-setting/profiles`;
export const URL_WORKER_PARTICIPANT_COMPLIANCE_PROFILES = `${BASE_URL}worker/participant-compliance-setting/profiles`;
export const URL_SP_PARTICIPANT_COMPLIANCE_PROFILE = (uuid) =>
  `${BASE_URL}sp/participant-compliance-setting/profiles/${uuid}`;
export const URL_SP_PARTICIPANT_COMPLIANCE_PROFILE_DELETE_PREVIEW = (uuid) =>
  `${BASE_URL}sp/participant-compliance-setting/profiles/${uuid}/delete-preview`;
export const URL_SP_PARTICIPANT_COMPLIANCE_SETTING = `${BASE_URL}sp/participant-compliance-setting`;
export const URL_SP_PARTICIPANT_COMPLIANCE_SETTING_UPDATE = `${BASE_URL}sp/participant-compliance-setting/update`;
export const URL_SP_PARTICIPANT_COMPLIANCE_ADD_DOCUMENT = `${BASE_URL}sp/participant-compliance-setting/documents`;
export const URL_SP_PARTICIPANT_COMPLIANCE_UPDATE_DOCUMENT = (uuid) =>
  `${BASE_URL}sp/participant-compliance-setting/documents/${uuid}`;
export const URL_SP_PARTICIPANT_COMPLIANCE_CREATE_CATEGORY = `${BASE_URL}sp/participant-compliance-setting/categories`;
export const URL_SP_PARTICIPANT_COMPLIANCE_CATEGORY_VISIBILITY = (uuid) => `${BASE_URL}sp/participant-compliance-setting/categories/${uuid}`;
export const URL_SP_PARTICIPANT_COMPLIANCE_CATEGORY_UPDATE = (uuid) => `${BASE_URL}sp/participant-compliance-setting/categories/${uuid}`;
export const URL_SP_PARTICIPANT_COMPLIANCE_CATEGORY_DELETE = (uuid) => `${BASE_URL}sp/participant-compliance-setting/categories/${uuid}`;
export const URL_SP_PARTICIPANT_COMPLIANCE_DELETE_DOCUMENT = (uuid) => `${BASE_URL}sp/participant-compliance-setting/documents/${uuid}`;
export const URL_SP_PARTICIPANT_DOCUMENTS_LIST = `${BASE_URL}sp/participant/documents-list`;
export const URL_SP_PARTICIPANT_COMPLIANCE_DOCS = `${BASE_URL}sp/participant/compliance-docs`;
export const URL_HRM_PARTICIPANT_DOCUMENTS_LIST = `${BASE_URL}hrm/participant/documents-list`;
export const URL_HRM_PARTICIPANT_COMPLIANCE_DOCS = `${BASE_URL}hrm/participant/compliance-docs`;
export const URL_HRM_PARTICIPANT_UPLOAD_REQUIRED_DOCUMENT = `${BASE_URL}hrm/file-management/participant/upload-required-document`;
export const URL_SP_PARTICIPANT_UPLOAD_REQUIRED_DOCUMENT = `${BASE_URL}sp/file-management/participant/upload-required-document`;

// Journey Tracking
export const URL_JOURNEY_EVENTS = `${BASE_URL}sp/journey/events`;
export const URL_JOURNEY_SESSIONS = `${BASE_URL}sp/journey/sessions`;
export const URL_JOURNEY_SESSION_DETAIL = (sessionId) => `${BASE_URL}sp/journey/session/${sessionId}`;
export const URL_JOURNEY_ACTIVE_USERS = `${BASE_URL}sp/journey/active-users`;

// Rostering Settings
export const URL_SP_ROSTERING_SETTING = `${BASE_URL}sp/general-setting`;
export const URL_WORKER_ROSTERING_SETTING = `${BASE_URL}hrm/general-setting`;
export const URL_SP_ROSTERING_SETTING_UPDATE = `${BASE_URL}sp/general-setting/update`;

// Worker leave — scheduled shift overlap check (before create / on approve preview)
export const URL_SP_CHECK_WORKER_LEAVE_SHIFT_OVERLAP = `${BASE_URL}sp/check-worker-leave-overlapping-with-shift`;
export const URL_HRM_CHECK_WORKER_LEAVE_SHIFT_OVERLAP = `${BASE_URL}hrm/check-worker-leave-overlapping-with-shift`;

//Stirpe
export const URL_SP_STRIPE_PRICING_TABLE_LIST = `${BASE_URL}sp/stripe/get/pricing`;
export const URL_SP_STRIPE_ONBOARDING_FEE = `${BASE_URL}sp/stripe/get/onboarding-fee`;
export const URL_SP_STRIPE_ATTACH_PAYMENT_METHOD = `${BASE_URL}sp/stripe/attach/customer/payment-method`;
export const URL_SP_STRIPE_LIST_ALL_CARD = `${BASE_URL}sp/stripe/customer/payment-methods`;
export const URL_SP_STRIPE_BUY_PLAN = `${BASE_URL}sp/stripe/create/subscription`;
export const URL_SP_STRIPE_GET_DEFAULT_PAYMENT_METHOD = `${BASE_URL}sp/stripe/get/payment-settings`;
export const URL_SP_STRIPE_CURRENT_SUBSCRIPTION = `${BASE_URL}sp/stripe/get/subscription`;
export const URL_SP_STRIPE_MAKE_CARD_DEFAULT = `${BASE_URL}sp/stripe/make-default/customer/payment-method`;
export const URL_SP_STRIPE_DETTACH_CARD = `${BASE_URL}sp/stripe/detach/customer/payment-method`;
export const URL_SP_STRIPE_INVOICES = `${BASE_URL}sp/stripe/get/all-invoices`;
export const URL_SP_STRIPE_RETRY_PAYMENT = `${BASE_URL}sp/stripe/payment/retry-charge`;
export const URL_SP_STRIPE_COUPON_INFO = `${BASE_URL}sp/stripe/coupon/info`;

//--------------------------- PARTICIPANT --------------------------------//

export const URL_GET_PARTICIPANT = `${BASE_URL}sp/participants`;
export const URL_PARTICIPANT_SUPPORT_PLAN = `${BASE_URL}sp/participant/support-plan`;
export const URL_PARTICIPANT_SETTING = `${BASE_URL}sp/participants/setting-update`;
export const URL_PARTICIPANT_SETTING_WORKER = `${BASE_URL}worker/participants/setting-update`;
export const URL_PARTICIPANT_SHIFT_TASKS_NOTES = (uuid) =>
  `${BASE_URL}sp/participants/${uuid}/shift-tasks-notes`;
export const URL_PARTICIPANT_APPOINTMENT = `${BASE_URL}sp/participant-appointment`;

//-----------------------------------MEDICATION--------------------------------//
export const URL_PARTICIPANT_STORE_MEDICATION = `${BASE_URL}sp/mar/store-medication`;
export const URL_PARTICIPANT_GET_MEDICATION_LIST = `${BASE_URL}sp/mar/get-medications`;
export const URL_PARTICIPANT_STORE_ADRS = `${BASE_URL}sp/mar/store-adrs`;
export const URL_PARTICIPANT_UPDATE_ADRS = `${BASE_URL}sp/mar/update-adrs`;
export const URL_PARTICIPANT_DELETE_ADRS = `${BASE_URL}sp/mar/delete-adrs`;
export const URL_PARTICIPANT_GET_MEDICATION_LIST_HRM = `${BASE_URL}hrm/mar/get-medications`;
export const URL_PARTICIAPNT_UPDATE_MEDICATION = `${BASE_URL}sp/mar/update-medication-log`;
export const URL_PARTICIPANT_GET_SINGLE_MEDICATION = `${BASE_URL}sp/mar/get-medication-log`;
export const URL_PARTICIPANT_GET_SINGLE_MEDICATION_HRM = `${BASE_URL}hrm/mar/get-medication-log`;
export const URL_PARTICIPANT_REMOVE_MEDICATION_ATTACHMENT = `${BASE_URL}sp/mar/delete-attachment`;
export const URL_PARTICIPANT_MEDICATION_TABLE_LIST = `${BASE_URL}sp/mar/get-medication-records`;
export const URL_PARTICIPANT_MEDICATION_TABLE_LIST_HRM = `${BASE_URL}hrm/mar/get-medication-records`;
export const URL_PARTICIPANT_MEDICATION_HISTORY_EXPORT = `${BASE_URL}sp/mar/export-medication-history-report`;
export const URL_PARTICIPANT_MEDICATION_HISTORY_EXPORT_HRM = `${BASE_URL}hrm/mar/export-medication-history-report`;

export const URL_PARTICIPANT_DELETE_SINGLE_MEDICATION = `${BASE_URL}sp/mar/delete-participant-medication`;
export const URL_PARTICIPANT_UPDATE_MEDICATION = `${BASE_URL}sp/mar/medication-update`;
//---------------------------HRM--------------------------------//

export const URL_HRM_FORM_CATEGORIES = `${BASE_URL}sp/hrm/form-categories`;
export const URL_SP_APPLICANTS = `${BASE_URL}hrm/recruitment-stages/applicants`;
export const URL_HRM_DOCUMENTS = `${BASE_URL}hrm/documents`;
export const URL_HRM_SUBMITTED_FORMS_LIST = `${BASE_URL}hrm/participant/submitted-forms`;
export const URL_HRM_APPOINTMENT = `${BASE_URL}hrm/participant-appointment`;
export const URL_HRM_GET_PARTICIPANT = `${BASE_URL}hrm/participants`;
export const URL_HRM_EMPLOYEE_PARTICIPANTS = `${BASE_URL}hrm/employee-participants`;
export const URL_HRM_GET_TEAM_MANAGMENT = `${BASE_URL}sp/employee-list`;
export const URL_HRM_WORKER_PROFILE_DETAIL = `${BASE_URL}sp/employee-profile`;
export const URL_HRM_WORKER_GENERAL_SETTING = `${BASE_URL}hrm/worker-settings`;
export const URL_HRM_WORKER_STATUS_UPDATE = `${BASE_URL}hrm/employee/update-status`;
export const URL_HRM_WORKER_DEACTIVATE_FUTURE_SHIFTS_COUNT = `${BASE_URL}hrm/employee/deactivate-future-shifts-count`;
export const URL_EMPLOYEE_HRM_FORM_CATEGORIES = `${BASE_URL}worker/hrm/form-categories`;
export const URL_EMPLOYEE_HRM_SUBMITTED_FORMS_LIST_BY_CATEGORY = `${BASE_URL}worker/hrm/submitted-forms`;

export const URL_HRM_DELETE_CASE_NOTE_ATTACHMENT = `${BASE_URL}hrm/case-note/attachment`;
export const URL_HRM_FORM_EMAIL_SEND = `${BASE_URL}sp/hrm-form_data/send-emails`;
//folder structure
export const URL_HRM_PARTICIPANT_CREATE_FOLDER = `${BASE_URL}hrm/folder/participant/store`;

//Ex...

export const URL_GET_FILE = `${BASE_URL}sp/file-management/view-file`;
export const URL_WORKER_GET_FILE = `${BASE_URL}hrm/file-management/view-file`;

//---------------------------COS--------------------------------//

export const URL_DASHBOARD_DATA = `${BASE_URL}cos/dashboard-stats`;
export const AH_URL_DASHBOARD_DATA = `${BASE_URL}ah/dashboard-stats`;
export const URL_GET_COS_PARTICIPANT = `${BASE_URL}cos/participant`;
export const AH_URL_GET_COS_PARTICIPANT = `${BASE_URL}ah/participant`;
export const URL_GET_COS_CASE_NOTE_DETAIL = `${BASE_URL}cos/case-notes/show`;
export const AH_URL_GET_COS_CASE_NOTE_DETAIL = `${BASE_URL}ah/case-notes/show`;
export const CATALOG_SERVICES = `${BASE_URL}cos/price-catalogs`;
export const AH_CATALOG_SERVICES = `${BASE_URL}ah/price-catalogs`;
export const CATALOG_SERVICES_SUB_CATEGORY = `${BASE_URL}cos/states`;
export const AH_CATALOG_SERVICES_SUB_CATEGORY = `${BASE_URL}ah/states`;
export const URL_CATALOG_VERSION = `${BASE_URL}cos/version-list`;
export const AH_URL_CATALOG_VERSION = `${BASE_URL}ah/version-list`;
export const URL_UPDATE_CASE_NOTE = `${BASE_URL}cos/case-notes/update`;
export const URL_COS_DELETE_CASE_NOTE_ATTACHMENT = `${BASE_URL}cos/case-notes/attachment`;
export const AH_URL_UPDATE_CASE_NOTE = `${BASE_URL}ah/case-notes/update`;
export const AH_URL_COS_DELETE_CASE_NOTE_ATTACHMENT = `${BASE_URL}ah/case-notes/attachment`;
export const URL_FUNDING_SETUP_CREATE = `${BASE_URL}cos/funding/store`;
export const AH_URL_FUNDING_SETUP_CREATE = `${BASE_URL}ah/funding/store`;
export const URL_FUNDING_SETUP_UPDATE = `${BASE_URL}cos/funding/update`;
export const AH_URL_FUNDING_SETUP_UPDATE = `${BASE_URL}ah/funding/update`;
export const URL_FUNDING_CHECK_MANAGEMENT_IMPACT = `${BASE_URL}cos/funding/check-management-update-impact`;
export const AH_URL_FUNDING_CHECK_MANAGEMENT_IMPACT = `${BASE_URL}ah/funding/check-management-update-impact`;
export const URL_FUNDING_SETUP_PARTICIPAANT = `${BASE_URL}cos/funding/participant`;
export const AH_URL_FUNDING_SETUP_PARTICIPAANT = `${BASE_URL}ah/funding/participant`;
export const URL_FUNDING_SETUP_PARTICIPAANT_FOR_COS = `${BASE_URL}cos/funding/cos-participant`;
export const AH_URL_FUNDING_SETUP_PARTICIPAANT_FOR_COS = `${BASE_URL}ah/funding/cos-participant`;
export const URL_SELECTED_FUNDING_SETUP = `${BASE_URL}cos/funding/show`;
export const AH_URL_SELECTED_FUNDING_SETUP = `${BASE_URL}ah/funding/show`;
export const URL_FUNDING_DELETE = `${BASE_URL}cos/funding`;
export const AH_URL_FUNDING_DELETE = `${BASE_URL}ah/funding`;
export const URL_PLAN_CATAGORIES = `${BASE_URL}cos/service-sub-categories`;
export const AH_URL_PLAN_CATAGORIES = `${BASE_URL}ah/service-sub-categories`;
export const URL_PLAN_BUDGET = `${BASE_URL}cos/plan-budget/store`;
export const AH_URL_PLAN_BUDGET = `${BASE_URL}ah/plan-budget/store`;
export const URL_PLAN_BUDGET_UPDATE = `${BASE_URL}cos/plan-budget/update`;
export const AH_URL_PLAN_BUDGET_UPDATE = `${BASE_URL}ah/plan-budget/update`;
export const URL_PLAN_BUDGET_LIST = `${BASE_URL}cos/plan-budget`;
export const AH_URL_PLAN_BUDGET_LIST = `${BASE_URL}ah/plan-budget`;
export const URL_SERVICE_CATEGORY = `${BASE_URL}cos/sp-category-budget`;
export const AH_URL_SERVICE_CATEGORY = `${BASE_URL}ah/sp-category-budget`;
export const URL_EXTERNAL_SP = `${BASE_URL}cos/external-sp`;
export const AH_URL_EXTERNAL_SP = `${BASE_URL}ah/external-sp`;
export const URL_PLAN_BUDGET_CAT_AND_SUB_CAT = `${BASE_URL}cos/plan-budget-cat`;
export const AH_URL_PLAN_BUDGET_CAT_AND_SUB_CAT = `${BASE_URL}ah/plan-budget-cat`;
export const URL_SERVICE_PROVIDER_CATEGORY_PLAN_BUDGET_UPDATE = `${BASE_URL}cos/sp-category-budget-update`;
export const AH_URL_SERVICE_PROVIDER_CATEGORY_PLAN_BUDGET_UPDATE = `${BASE_URL}ah/sp-category-budget-update`;
export const URL_SERVICE_PROVIDER_CATEGORY_PLAN_BUDGET = `${BASE_URL}cos/sp-category-budget`;
export const AH_URL_SERVICE_PROVIDER_CATEGORY_PLAN_BUDGET = `${BASE_URL}ah/sp-category-budget`;
export const URL_SERVICE_PROVIDER_CATEGORY_PLAN_BUDGET_LIST = `${BASE_URL}cos/sp-category-budget-list`;
export const AH_URL_SERVICE_PROVIDER_CATEGORY_PLAN_BUDGET_LIST = `${BASE_URL}ah/sp-category-budget-list`;
export const URL_SEARCH_CATALOG_SERVICES = `${BASE_URL}cos/service-support-budget/service-search`;
export const AH_URL_SEARCH_CATALOG_SERVICES = `${BASE_URL}ah/service-support-budget/service-search`;
export const URL_FUNDING_NOTES_LIST = `${BASE_URL}cos/funding-notes`;
export const AH_URL_FUNDING_NOTES_LIST = `${BASE_URL}ah/funding-notes`;
export const URL_FUNDING_NOTES_LIST_UPDATE = `${BASE_URL}cos/funding-notes-update`;
export const AH_URL_FUNDING_NOTES_LIST_UPDATE = `${BASE_URL}ah/funding-notes-update`;
export const URL_SERVICE_SUPPORT_BUDGET_STORE = `${BASE_URL}cos/service-support-budget/store`;
export const AH_URL_SERVICE_SUPPORT_BUDGET_STORE = `${BASE_URL}ah/service-support-budget/store`;
export const URL_SERVICE_SUPPORT_BUDGET_UPDATE = `${BASE_URL}cos/service-support-budget/update`;
export const AH_URL_SERVICE_SUPPORT_BUDGET_UPDATE = `${BASE_URL}ah/service-support-budget/update`;
export const URL_SERVICE_SUPPORT_BUDGET_LIST = `${BASE_URL}cos/service-support-budget`;
export const AH_URL_SERVICE_SUPPORT_BUDGET_LIST = `${BASE_URL}ah/service-support-budget`;
export const URL_SERVICE_SUPPORTS_FOR_DELIVERED_SERVICE = `${BASE_URL}cos/delivered-service/fetch-plan-budget-category-with-services`;
export const AH_URL_SERVICE_SUPPORTS_FOR_DELIVERED_SERVICE = `${BASE_URL}ah/delivered-service/fetch-plan-budget-category-with-services`;
export const URL_COS_PARTICIPANT_LIST = `${BASE_URL}cos/participants`;
export const AH_URL_COS_PARTICIPANT_LIST = `${BASE_URL}ah/participants`;
export const URL_SUPPORT_COORDINATOR = `${BASE_URL}cos/support-coordinates`;
export const AH_URL_SUPPORT_COORDINATOR = `${BASE_URL}ah/support-coordinates`;
export const URL_DELIVERED_SERVICE_STORE = `${BASE_URL}cos/delivered-service/store`;
export const AH_URL_DELIVERED_SERVICE_STORE = `${BASE_URL}ah/delivered-service/store`;
export const URL_MANUAL_DELIVERED_SERVICE_STORE = `${BASE_URL}cos/delivered-service/store-manual`;
export const AH_URL_MANUAL_DELIVERED_SERVICE_STORE = `${BASE_URL}ah/delivered-service/store-manual`;
export const URL_DELIVERED_SERVICE = `${BASE_URL}cos/delivered-service`;
export const AH_URL_DELIVERED_SERVICE = `${BASE_URL}ah/delivered-service`;
export const URL_MANUAL_DELIVERIES = `${BASE_URL}cos/delivered-service/manual-delivery`;
export const AH_URL_MANUAL_DELIVERIES = `${BASE_URL}ah/delivered-service/manual-delivery`;
export const URL_CREATE_CASENOTES = `${BASE_URL}cos/case-notes`;
export const AH_URL_CREATE_CASENOTES = `${BASE_URL}ah/case-notes`;
export const URL_GET_CASENOTES = `${BASE_URL}cos/case-notes`;
export const AH_URL_GET_CASENOTES = `${BASE_URL}ah/case-notes`;
export const URL_UPDATE_CLIENT_TASK = `${BASE_URL}cos/client-tasks-update`;
export const AH_URL_UPDATE_CLIENT_TASK = `${BASE_URL}ah/client-tasks-update`;
export const URL_CREATE_CLIENT_TASKS = `${BASE_URL}cos/client-tasks`;
export const AH_URL_CREATE_CLIENT_TASKS = `${BASE_URL}ah/client-tasks`;
export const URL_DELETE_CLIENT_TASKS = `${BASE_URL}cos/client-tasks/`;
export const AH_URL_DELETE_CLIENT_TASKS = `${BASE_URL}ah/client-tasks/`;
export const URL_GET_SINGLE_SUPPORT_TRACK = `${BASE_URL}cos/case-notes/support-track`;
export const AH_URL_GET_SINGLE_SUPPORT_TRACK = `${BASE_URL}ah/case-notes/support-track`;
export const URL_GET_CASE_NOTES_CLIENTS = `${BASE_URL}cos/case-notes/clients`;
export const AH_URL_GET_CASE_NOTES_CLIENTS = `${BASE_URL}ah/case-notes/clients`;
export const URL_GET_CASE_NOTES_HISTORY_List = `${BASE_URL}cos/case-notes/history`;
export const AH_URL_GET_CASE_NOTES_HISTORY_List = `${BASE_URL}ah/case-notes/history`;
export const URL_GET_CASE_NOTES_LIST_FOR_NDIS_CLAIM = `${BASE_URL}cos/case-notes/ndis-claims`;
export const AH_URL_GET_CASE_NOTES_LIST_FOR_NDIS_CLAIM = `${BASE_URL}ah/case-notes/ndis-claims`;
export const URL_ADD_CASE_NOTES_TO_NDIS_CLAIM_LIST = `${BASE_URL}cos/case-notes/create-claims`;
export const AH_URL_ADD_CASE_NOTES_TO_NDIS_CLAIM_LIST = `${BASE_URL}ah/case-notes/create-claims`;
export const URL_GET_CLAIMED_CASE_NOTES_LIST = `${BASE_URL}cos/case-notes/created-claims-list`;
export const AH_URL_GET_CLAIMED_CASE_NOTES_LIST = `${BASE_URL}ah/case-notes/created-claims-list`;
export const URL_GET_CASE_NOTES_REVIEW = `${BASE_URL}cos/case-notes/ndis-claim-review`;
export const AH_URL_GET_CASE_NOTES_REVIEW = `${BASE_URL}ah/case-notes/ndis-claim-review`;
export const URL_GEL_REPORTING = `${BASE_URL}cos/reporting`;
export const AH_URL_GEL_REPORTING = `${BASE_URL}ah/reporting`;
export const URL_GET_SERVICE_PROVIDER_SERCH_RESULT = `${BASE_URL}cos/case-notes/external-sp`;
export const AH_URL_GET_SERVICE_PROVIDER_SERCH_RESULT = `${BASE_URL}ah/case-notes/external-sp`;
export const URL_CREATE_COS_INVOICES = `${BASE_URL}cos/case-notes/create-cos-invoices`;
export const AH_URL_CREATE_COS_INVOICES = `${BASE_URL}ah/case-notes/create-cos-invoices`;
export const URL_EMAIL_COS_INVOICE_TO_PLAN_MANAGER = `${BASE_URL}sp/cos/case-notes/email-cos-invoice-to-plan-manager`;
export const URL_GET_COS_INVOICES = `${BASE_URL}cos/case-notes/cos-invoices`;
export const AH_URL_GET_COS_INVOICES = `${BASE_URL}ah/case-notes/cos-invoices`;
export const URL_GET_CREATED_COS_INVOICES = `${BASE_URL}cos/case-notes/created-cos-invoices-list`;
export const AH_URL_GET_CREATED_COS_INVOICES = `${BASE_URL}ah/case-notes/created-cos-invoices-list`;
export const URL_GET_CREATED_COS_INVOICES_PREVIEW_LIST = `${BASE_URL}cos/case-notes/cos-invoice-review`;
export const AH_URL_GET_CREATED_COS_INVOICES_PREVIEW_LIST = `${BASE_URL}ah/case-notes/cos-invoice-review`;
export const URL_GET_COS_INVOICE_MODE = `${BASE_URL}cos/case-notes/cos-invoice-mode`;
export const AH_URL_GET_COS_INVOICE_MODE = `${BASE_URL}ah/case-notes/cos-invoice-mode`;
export const URL_GET_NDIS_CLAIM_MODE = `${BASE_URL}cos/case-notes/ndis-claim-mode`;
export const AH_URL_GET_NDIS_CLAIM_MODE = `${BASE_URL}ah/case-notes/ndis-claim-mode`;
export const URL_CHANGE_NDIS_CLAIM_ACTIONS = `${BASE_URL}cos/case-notes/ndis-claim-actions`;
export const AH_URL_CHANGE_NDIS_CLAIM_ACTIONS = `${BASE_URL}ah/case-notes/ndis-claim-actions`;
export const URL_CHANGE_NDIS_INVOICE_CLAIM_ACTIONS = `${BASE_URL}cos/case-notes/cos-invoice-actions`;
export const AH_URL_CHANGE_NDIS_INVOICE_CLAIM_ACTIONS = `${BASE_URL}ah/case-notes/cos-invoice-actions`;
export const URL_COS_CATEGORY_SETTING_DATA_COS = `${BASE_URL}cos/client-task-category-list`;
export const AH_URL_COS_CATEGORY_SETTING_DATA_COS = `${BASE_URL}ah/client-task-category-list`;
export const URL_TASK_PRIORITY_SETTING_CREATE_UPDATE_COS = `${BASE_URL}cos/client-task-category`;
export const AH_URL_TASK_PRIORITY_SETTING_CREATE_UPDATE_COS = `${BASE_URL}ah/client-task-category`;
export const URL_COS_CONTACT_SETTING_DATA_COS = `${BASE_URL}cos/contact-types-list`;
export const AH_URL_COS_CONTACT_SETTING_DATA_COS = `${BASE_URL}ah/contact-types-list`;
export const URL_CONTACT_TYPE_SETTING_CREATE_UPDATE_COS = `${BASE_URL}cos/contact-types`;
export const AH_URL_CONTACT_TYPE_SETTING_CREATE_UPDATE_COS = `${BASE_URL}ah/contact-types`;
export const URL_COS_PRIORITY_SETTING_DATA_COS = `${BASE_URL}cos/cos-priority-list`;
export const AH_URL_COS_PRIORITY_SETTING_DATA_COS = `${BASE_URL}ah/cos-priority-list`;
export const URL_COS_PERIORITY_SETTING_CREATE_UPDATE_COS = `${BASE_URL}cos/cos-priority`;
export const AH_URL_COS_PERIORITY_SETTING_CREATE_UPDATE_COS = `${BASE_URL}ah/cos-priority`;
export const URL_GET_CATALOG_PRICE_AGAINST_STATE = `${BASE_URL}cos/service-support-budget/price-catalog-price-against-state`;
export const AH_URL_GET_CATALOG_PRICE_AGAINST_STATE = `${BASE_URL}ah/service-support-budget/price-catalog-price-against-state`;

export const URL_GET_SUPPORT_TRACK_LIST = `${BASE_URL}sp/cos/case-notes/list-for-support-track`;
export const AH_URL_GET_SUPPORT_TRACK_LIST = `${BASE_URL}sp/ah/case-notes/list-for-support-track`;

//Rostering Url's
export const URL_ROSTERING_WORKER_AND_PARTICIPANT_LIST = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/worker_participant_list`;
export const URL_ROSTERING_SHIFT = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift`;
/** Lean listing for Delete Shifts modal (flat shifts, not full calendar payload). */
export const URL_ROSTERING_SHIFT_DELETABLE_LIST = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift/deletable-list`;
export const URL_ROSTERING_SHIFT_ADVANCE = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/shift/advance`;
export const URL_ROSTERING_SHIFT_V5 = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/shift`;
/** Incomplete advance-shift builders (JSON staging — not real shifts). */
export const URL_ROSTERING_SHIFT_DRAFTS = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/shift-drafts`;
export const URL_SHIFT_HISTORY = `${BASE_URL.replace(
  /v2/,
  "v1"
)}sp/rostering/shift_history`;
export const URL_ROSTERING_SHIFT_STATUS_CHANGE = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/change_shift_status`;
export const URL_ROSTERING_SHIFT_COPY = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/copy_shift`;
export const URL_ROSTERING_V5_SHIFT_COPY = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/copy_shift`;

const V5_ROSTERING_BASE = `${BASE_URL.replace(/v1/, "v5")}sp/rostering`;

export const URL_V5_SHIFTS_BILLING_ALLOCATION_LIST = `${V5_ROSTERING_BASE}/shifts/billing-allocation`;

export const URL_V5_SHIFTS_FOR_INVOICE_LIST = `${V5_ROSTERING_BASE}/shifts/for-invoice`;

export const URL_V5_SHIFT_BILLING_ALLOCATION = (shiftUuid) =>
  `${V5_ROSTERING_BASE}/shift/${shiftUuid}/billing-allocation`;

export const URL_V5_SHIFT_BILLING_BREAKDOWN_PREVIEW = (shiftUuid) =>
  `${V5_ROSTERING_BASE}/shift/${shiftUuid}/billing-breakdown-preview`;

export const URL_V5_SHIFT_SPLITS = (shiftId) =>
  `${V5_ROSTERING_BASE}/shift/${shiftId}/splits`;
export const URL_ROSTERING_V5_FORTNIGHTLY_COPY_SHIFT = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/copy_shifts`;
export const URL_ROSTERING_V5_COPY_FORTHNIGHTLY_OVERLAPPING_CHECK = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/copy_shifts/check-overlapping`;
export const URL_ROSTERING_WORKER_TIMESHEETS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/worker_time_sheet`;
export const URL_ROSTERING_PARTICIPANT_LIST_FOR_TIMESHEETS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/participants_list_by_timesheet`;
export const URL_ROSTERING_TIMESHEET_COMMENTS = `${BASE_URL}sp/rostering/timesheet_comment_list`;
export const URL_ROSTERING_CREATE_TIMESHEET_COMMENT = `${BASE_URL}sp/rostering/create_comment`;
export const URL_ROSTERING_UPDATE_TIMESHEET_DATA = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/timesheet`;
export const URL_ROSTERING_CHANGE_TIMESHEET_STATUS = `${BASE_URL}sp/rostering/change_status`;
export const URL_ROSTERING_LATEST_SHIFT_PARTICIPANTS = `${BASE_URL}sp/rostering/latest-shift-participant`;
export const URL_ROSTERING_WORKERS_TIMESHEET_EXPORT_LIST = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/time-sheet-export/worker_time_sheet`;
export const URL_ROSTERING_SHIFT_STATS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shiftsStats`;

// url for targeting participant nots.
export const URL_PARTICIPANTS_SHIFT_NOTES = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/get_shift_notes`;

// url for targeting participant notes, access for standard user

export const URL_PARTICIPANTS_SHIFT_NOTES_STANDARD_USER = `${BASE_URL.replace(
  /v1/,
  "v2"
)}hrm/get_shift_notes`;

// Export shift notes URLs
export const URL_EXPORT_SHIFT_NOTES_CSV = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/export_shift_notes_csv`;

export const URL_EXPORT_SHIFT_NOTES_PDF = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/export_shift_notes_pdf`;

export const URL_EXPORT_SHIFT_NOTES_CSV_STANDARD_USER = `${BASE_URL.replace(
  /v1/,
  "v2"
)}hrm/export_shift_notes_csv`;

export const URL_EXPORT_SHIFT_NOTES_PDF_STANDARD_USER = `${BASE_URL.replace(
  /v1/,
  "v2"
)}hrm/export_shift_notes_pdf`;

export const URL_ROSTERING_SHIFT_END_QUESTION = `${BASE_URL}sp/shift-end-question/show`;
export const URL_ROSTERING_SHIFT_END_QUESTION_FOR_WORKER = `${BASE_URL}worker/shift-end-question/show`;
export const URL_ROSTERING_SHIFT_END_ANSWERS = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/shift_end_answer_list/`;

export const URL_ROSTERING_SHIFT_HISTORY = `${BASE_URL}sp/rostering/shift_history/`;

export const URL_ROSTERING_GET_OPEN_SHIFTS = `${BASE_URL}sp/rostering/get-open-shifts/`;
export const URL_SP_SHIFT_REQUESTS = `${BASE_URL}sp/shift-requests`;
export const URL_SP_SHIFT_REQUEST_STATUS = `${BASE_URL}sp/shift-requests`;
export const URL_SP_SHIFT_REQUEST_DETAIL = `${BASE_URL}sp/shift-requests`;
export const URL_ROSTERING_APPROVE_OPEN_SHIFTS = `${BASE_URL}sp/rostering/approve-shift-request/`;

export const URL_ROSTERING_SINGLE_TIMESHEET_DETAILS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/time-sheet-export/get-single-time-sheet`;

export const URL_ROSTERING_CHECK_PAYROLL_AUTHENTICATION = `${BASE_URL}sp/payroll/check-authentication`;
export const URL_ROSTERING_XERO_LOGIN = `${BASE_URL.replace(
  /\/api\/v1\//,
  "/"
)}xero/login`;
export const URL_ROSTERING_QUICK_BOOKS_LOGIN = `${BASE_URL.replace(
  /\/api\/v1\//,
  "/"
)}quick-books/login`;
export const URL_ROSTERING_MYOB_LOGIN = `${BASE_URL.replace(
  /\/api\/v1\//,
  "/"
)}myob/login`;
export const URL_QUICK_BOOKS_EMPLOYEE = `${BASE_URL}sp/payroll/get-employees`;
export const URL_QUICK_BOOKS_SYNC_EMPLOYEE = `${BASE_URL}sp/payroll/quick-books/sync-employees`;
export const URL_ROSTERING_EXPORT_TIMESHEET_TO_PAYROLL = `${BASE_URL}sp/payroll/create/timesheet`;
export const URL_PAYROLL_CONNECT = `${BASE_URL}sp/payroll/connect`;
export const URL_PAYROLL_QUICKBOOKS_BUSINESSES = `${BASE_URL}sp/payroll/quick-books/get-businesses`;
export const URL_PAYROLL_MYOB_BUSINESSES = `${BASE_URL}sp/payroll/myob/get-businesses`;
export const URL_PAYROLL_MYOB_EMPLOYEES = `${BASE_URL}sp/payroll/myob/get-employees`;
export const URL_PAYROLL_SYNC_MYOB_EMPLOYEES = `${BASE_URL}sp/payroll/myob/sync-employees`;
export const URL_PAYROLL_MYOB_CATEGORIES = `${BASE_URL}sp/payroll/myob/get-categories`;
export const URL_PAYROLL_SYNC_MYOB_CATEGORIES = `${BASE_URL}sp/payroll/myob/sync-categories`;

export const URL_WYZED_STATUS = `${BASE_URL}sp/wyzed/status`;
export const URL_WYZED_CONNECT = `${BASE_URL}sp/wyzed/connect`;
export const URL_WYZED_DISCONNECT = `${BASE_URL}sp/wyzed/disconnect`;
export const URL_WYZED_WORKER_MAPPINGS_PREVIEW = `${BASE_URL}sp/wyzed/worker-mappings/preview`;
export const URL_WYZED_WORKER_MAPPINGS = `${BASE_URL}sp/wyzed/worker-mappings`;
export const URL_WYZED_CREATE_WORKER = (employeeProfileId) =>
  `${BASE_URL}sp/wyzed/workers/${employeeProfileId}/create`;
export const URL_WYZED_BULK_CREATE_WORKERS = `${BASE_URL}sp/wyzed/workers/bulk-create`;
export const URL_WYZED_WORKER_LINK = (employeeProfileId) =>
  `${BASE_URL}sp/wyzed/workers/${employeeProfileId}/link`;
export const URL_WYZED_SYNC = `${BASE_URL}sp/wyzed/sync`;
export const URL_WYZED_WORKER_TRAINING = (employeeProfileId) =>
  `${BASE_URL}sp/wyzed/workers/${employeeProfileId}/training`;
export const URL_WYZED_CERTIFICATE = (employeeProfileId, trainingRecordId) =>
  `${BASE_URL}sp/wyzed/workers/${employeeProfileId}/training/${trainingRecordId}/certificate`;

export const URL_WORKER_WYZED_STATUS = `${BASE_URL}worker/wyzed/status`;
export const URL_WORKER_WYZED_TRAINING = `${BASE_URL}worker/wyzed/training`;
export const URL_WORKER_WYZED_CERTIFICATE = (trainingRecordId) =>
  `${BASE_URL}worker/wyzed/training/${trainingRecordId}/certificate`;
export const URL_WORKER_WYZED_START_TRAINING = (trainingRecordId) =>
  `${BASE_URL}worker/wyzed/training/${trainingRecordId}/start`;

export const URL_ROSTERING_RECURRING_SHIFT = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/recurring_shift`;
export const URL_ROSTERING_FORTNIGHTLY_COPY_SHIFT = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/copy_shifts`;
export const URL_ROSTERING_INVOICING_GET_ITEM_NUMBER_ON_TIMESHEET = `${BASE_URL.replace(
  /v1/,
  "v2"
)}roster-invoices/get-item-detail`;
export const URL_ROSTERING_INVOICING_GET_TRAVEL_DETAILS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}roster-invoices/get-travel-detail`;

export const URL_ROSTER_LINK_TO_CORE_FUNDING = `${BASE_URL.replace(
  /v1/,
  "v2"
)}roster-invoices/link-rostering-with-core-funding`;

export const URL_ROSTERING_GET_RECURRING_SHIFT_ON_EDIT_MESSAGE = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift/impacted-count`;

export const URL_ROSTERING_COPY_FORTHNIGHTLY_OVERLAPPING_CHECK = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/copy_shifts/check-overlapping`;
export const URL_ROSTERING_GET_SHIFT_INSTRUCTIONS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift/shift_instructions`;

export const URL_ROSTERING_SIL_HOMES = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/sil-homes`;
export const URL_ROSTERING_SIL_HOME_PARTICIPANTS = (homeUuid) =>
  `${BASE_URL.replace(/v1/, "v5")}sp/rostering/sil-homes/${homeUuid}/participants`;
export const URL_ROSTERING_COMMON_RESOURCES = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/common-resources`;
export const URL_ROSTERING_SHIFT_LOCATION = `${BASE_URL.replace(
  /v1/,
  "v5"
)}sp/rostering/shift-location`;

export const URL_ROSTERING_GET_KM_CODE_LIST_IN_SETTING = `${BASE_URL.replace(
  /v1/,
  "v2"
)}roster-invoices/get-travel-detail/`;

//STARTPOINT New Timesheet Design URL's

export const URL_ROSTERING_NEW_TIMESHEET_GET_TIMESHEET_LIST_OF_WORKERS = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/get-timesheets-workers`;
export const URL_ROSTERING_TIMESHEET_GET_WORKERS_OF_TIMESHEET_FOR_TABLE = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/get-worker-timesheets`;
export const URL_ROSTERING_TIMESHEET_KPI_SUMMARY = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/kpi-summary`;
export const URL_ROSTERING_TIMESHEET_AI_ANOMALY = (timesheetId) =>
  `${BASE_URL.replace(/v1/, "v3")}sp/rostering/timesheets/${timesheetId}/ai-anomaly`;
export const URL_ROSTERING_TIMESHEET_STATUS_UPDATE = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/status-update`;
export const URL_ROSTERING_TIMESHEET_UNAPPROVE_FUNDING_ASSESSMENT = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/unapprove-funding-assessment`;
export const URL_ROSTERING_TIMESHEET_BULK_UNAPPROVE = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/bulk-unapprove`;
export const URL_ROSTERING_GET_SHIF_TASK = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/shift-tasks`;
export const URL_ROSTERING_UPDATE_SHIFT_TASK = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/shift-tasks-status`;
export const URL_ROSTERING_GET_ALL_DETAILS_OF_TIMESHEET = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/time-sheet-detail`;
export const URL_ROSTERING_GET_ALL_MEDICATION_LIST = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/participant-medication`;
export const URL_ROSTERING_GET_ALL_ATTACHMENTS = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/shift-attachments`;
export const URL_ROSTERING_DELETE_SINGLE_ATTACHMENT = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/shift-attachments/delete`;
export const URL_ROSTERING_UPLOAD_DOCUMENTS = `${BASE_URL.replace(/v1/, "v3")}sp/rostering/timesheets/shift-attachments/update`
export const URL_ROSTERING_TIMESHEET_DETAILS_UPDATE = `${BASE_URL.replace(/v1/, "v3")}sp/rostering/timesheets/detail-update`
export const URL_ROSTERING_TIMESHEET_UPDATE_CODE_ALLOCATION = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/timesheets/code-allocation/store`;
export const URL_ROSTERING_GET_NDIS_LINE_ITEMS_ON_SCHEDULING_SHIFT = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift_ndis_items`
export const URL_ROSTERING_GET_SPLIT_SHIFTS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift/split-shifts/`
export const URL_ROSTERING_GET_NEARBY_WORKERS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift/nearby-workers`;
export const URL_ROSTERING_GEOCODE_ADDRESS = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift/geocode-address`;

export const URL_ROSTERING_GET_SELECTED_SERVICE_SUPPORT = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/get-user-service-type`;
export const URL_ROSTERING_UPDATE_SERVICE_SUPPORT = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/update-user-service-type`;
//ENDINGPOINT New Timesheet Design

//Roster Invoicing
export const URL_GET_ROSTER_INVOICES = `${BASE_URL}roster-invoices/timesheets`;
export const URL_CUSTOM_LINE_ITEMS = `${BASE_URL}custom-line-items`;
export const URL_CREATE_ROSTER_INVOICES = `${BASE_URL}roster-invoices/create`;
export const URL_ROSTER_INVOICES_LIST = `${BASE_URL}roster-invoices/list`;
export const URL_ROSTERING_INVOICE_DETAIL = `${BASE_URL}roster-invoices/detail`;
export const URL_ROSTERING_INVOICE_STATUS_UPDATE = `${BASE_URL}roster-invoices/invoice`;
export const URL_ROSTER_INVOICE_OTHER_LINES = (invoiceUuid) => `${BASE_URL}roster-invoices/${invoiceUuid}/other-lines`;
export const URL_ROSTER_INVOICING_TIMESHEET_BREAKDOWN = `${BASE_URL.replace(
  /v1/,
  "v2"
)}roster-invoices/get-breakdown`;

export const URL_ROSTERING_SHIFT_CHECK_OVERLAPP = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/shift/check-overlapping`;
export const URL_ROSTERING_TIMESHEET_CHECK_OVERLAPPING = `${BASE_URL.replace(
  /v1/,
  "v2"
)}sp/rostering/timesheet/check-overlapping`;
export const URL_ROSTERING_MANUALY_END_SHAIFT = `${BASE_URL.replace(
  /v1/,
  "v3"
)}sp/rostering/shift/end-shift`;

export const URL_SHIFT_QUESTIONS_ADD = `${BASE_URL}sp/shift-end-question/add`;

//Roles and permissions
export const URL_ROLE_AND_PERMISSION = `${BASE_URL}sp/roles-and-permission/role`;
export const URL_ROLE_AND_PERMISSION_LIST = `${BASE_URL}sp/roles-and-permission/roles`;
export const URL_ROLE_AUTHENTICATE_USER = `${BASE_URL}get-role-authenticate-user`;
// Reporting Module
export const URL_REPORTING_PARTICIPANT_REPORTS = `${BASE_URL}sp/reporting/participant-report`;
export const URL_REPORTING_WORKER_REPORTS = `${BASE_URL}sp/reporting/support-worker-report`;
export const URL_REPORTING_ROC_REPORTS = `${BASE_URL}sp/reporting/roc-report`;
export const URL_REPORTING_TIMESHEET_REPORTS = `${BASE_URL}sp/reporting/time-sheet-report`;
export const URL_REPORTING_XERO_TIMESHEET_EXPORT_REPORT = `${BASE_URL}sp/reporting/xero-timesheet-export-report`;
export const URL_REPORTING_GET_SP_USERS_LIST = `${BASE_URL}sp/reporting/sp-users-list`;
export const URL_REPORTING_CASE_NOTES_REPORTS = `${BASE_URL}sp/reporting/participant-casenote-report`;
export const URL_REPORTING_WORKER_EXPIRING_DOCUMENT_REPORTS = `${BASE_URL}sp/reporting/worker-documents-report`;
export const URL_REPORTING_PARTICIPANT_EXPIRING_DOCUMENT_REPORTS = `${BASE_URL}sp/reporting/participant-documents-report`;
export const URL_REPORTING_KYP_REPORTS = `${BASE_URL}sp/reporting/kyp-report`;
export const URL_REPORTING_FEEDBACK_REPORTS = `${BASE_URL}sp/reporting/feedback-report`;
export const URL_REPORTING_COMPLAINTS_REPORTS = `${BASE_URL}sp/reporting/complaint-report`;
export const URL_REPORTING_ROC_WEEKLY_REPORTS = `${BASE_URL}sp/reporting/roc-weekly-overtime-report`;
export const URL_REPORTING_COS_REPORTS = `${BASE_URL}sp/reporting/cos-casenote-report`;
export const URL_REPORTING_COS_FUNDING_REPORTS = `${BASE_URL}sp/reporting/cos-funding-report`;
export const URL_REPORTING_SUMMARY_INVOICING_REPORTS = `${BASE_URL}sp/reporting/invoice-summary-report`;
export const URL_REPORTING_DETAILED_INVOICING_REPORTS = `${BASE_URL}sp/reporting/invoice-detail-report`;
export const URL_REPORTING_GET_INVOICING_SUPPORT_ITEM = `${BASE_URL}sp/reporting/invoice-detail-service-item`;
export const URL_REPORTING_INCIDENT_REPORTS = `${BASE_URL}sp/reporting/incident-report`;
export const URL_REPORTING_INCIDENT_MANAGEMENT = `${BASE_URL}sp/reporting/incident-management-report`;
export const URL_REPORTING_RISK_CATEGORY_IN_RISK_ASSESSMENT_REPORTS = `${BASE_URL}sp/reporting/risk-assessment-categories`;
export const URL_REPORTING_RISK_ASSSESSMENT_REPORTS = `${BASE_URL}sp/reporting/risk-assessment-report`;
/*NDIS Reporting module */
export const URL_REPORTING_NDIS_PARTICIPANT_LIST = `${BASE_URL}sp/reporting/ndia-participant-list`;
export const URL_REPORTING_NDIS_REPORTS = `${BASE_URL}sp/reporting/nida-managed-participant-claim-report`;
export const URL_REPORTING_EXPORTS = `${BASE_URL}sp/reporting/exports`;
export const URL_REPORTING_EXPORTS_THRESHOLD = `${BASE_URL}sp/reporting/exports/threshold`;
export const URL_REPORTING_EXPORT_BY_UUID = (uuid) =>
  `${BASE_URL}sp/reporting/exports/${uuid}`;
//Team Lead Module
export const URL_TEAM_LEAD_GET_REGION_AND_MANAGERS = `${BASE_URL}sp/team-leader/regions/create`;

export const URL_WORKER_GET_REGION = `${BASE_URL}worker/regions/create`;

export const URL_TEAM_LEAD_CREATE_REGION = `${BASE_URL}sp/team-leader/regions/store`;
export const URL_TEAM_LEAD_GET_REGION_LIST = `${BASE_URL}sp/team-leader/regions`;
export const URL_TEAM_LEAD_GET_REGION_BY_UUID = `${BASE_URL}sp/team-leader/regions/edit`;
export const URL_TEAM_LEAD_UPDATE_REGION = `${BASE_URL}sp/team-leader/regions/update`;
export const URL_TEAM_LEAD_REGIONS_STATUS = `${BASE_URL}sp/team-leader/regions/status`;
export const URL_TEAM_LEAD_GET_MANAGERS_REGIONS_LIST = `${BASE_URL}sp/team-leader/regions/sp-manager`;
export const URL_TEAM_LEAD_MANAGER_REGION_STATUS_UPDATE = `${BASE_URL}sp/team-leader/regions/status`;
export const URL_TEAM_LEAD_SP_REGION_STATUS_UPDATE = `${BASE_URL}sp/team-leader/sp-regions/status`;
// Sil Accommodation URL's
export const URL_SIL_PROPERTY_TYPE_LIST = `${BASE_URL}sil/property-type/list`;
export const URL_SIL_SDA_TYPE_LIST = `${BASE_URL}sil/sda-type/list`;
export const URL_SIL_ACCOMMODATION_CREATE = `${BASE_URL}sil/home/create`;
export const URL_SIL_ACCOMMODATION_LIST = `${BASE_URL}sil/home/list`;
export const URL_SIL_ACCOMMODATION_QUICK_VIEW = `${BASE_URL}sil/home/quick-view`;
export const URL_SIL_ACCOMMODATION_DETAIL = `${BASE_URL}sil/home/detail`;
export const URL_SIL_ACCOMMODATION_SETTINGS_UPDATE = `${BASE_URL}sil/home/update`;
export const URL_SIL_ACCOMMODATION_UPLOAD_IMAGE = `${BASE_URL}sil/home/image`;
export const URL_SIL_ACCOMMODATION_UPLOAD_ATTACHMENT = `${BASE_URL}sil/home/attachments`;
export const URL_SIL_ACCOMMODATION_DELETE_IMAGE = `${BASE_URL}sil/home/image/delete`;

export const URL_SIL_ROOMS_LIST = `${BASE_URL}sil/home/room/list`;
export const URL_SIL_ROOM_DETAIL = `${BASE_URL}sil/home/room/detail`;
export const URL_SIL_ROOM_CREATE = `${BASE_URL}sil/home/room/create`;
export const URL_SIL_ROOM_DELETE = `${BASE_URL}sil/home/room/delete`;
export const URL_SIL_ROOM_UPDATE = `${BASE_URL}sil/home/room/update`;
export const URL_SIL_ROOM_NAME_UPDATE = `${BASE_URL}sil/home/room/updateName`;
export const URL_SIL_ROOM_ATTACHMENTS = `${BASE_URL}sil/home/room/attachments`;
export const URL_SIL_ROOM_ATTACHMENT_DELETE = `${BASE_URL}sil/home/room/attachments/delete`;

//Sil Form
export const URL_SIL_FORM_CATEGORIES = `${BASE_URL}sil/form/categories`;
export const URL_SIL_FORM_LIST = `${BASE_URL}sil/form/list`;
export const URL_SIL_FORM_DRAFT_TO_PUBLISH = `${BASE_URL}sil/form/draft-publish`;
export const URL_SIL_ACCOMMODATION_FORM_LIST_BY_CATEGORY = `${BASE_URL}sil/form/category-forms`;

export const URL_SIL_ACCOMMODATION_SUBMITTED_FORM_LIST = `${BASE_URL}sil/home/form/list`;
export const URL_SIL_ACCOMMODATION_SUBMITTED_FORM_DETAIL = `${BASE_URL}sil/home/form/detail`;
export const URL_SIL_ACCOMMODATION_SUBMITTED_FORM_UPDATE = `${BASE_URL}sil/home/form/update`;
export const URL_SIL_ACCOMMODATION_FORM_DATA_BY_SLUG = `${BASE_URL}sil/home/form/by-slug`;

//Sil Case Notes
export const URL_SIL_ACCOMMODATION_CASE_NOTES_LIST = `${BASE_URL}sil/home/note/list`;
export const URL_SIL_ACCOMMODATION_CASE_NOTE_CREATE = `${BASE_URL}sil/home/note/create`;
export const URL_SIL_ACCOMMODATION_CASE_NOTE_UPDATE = `${BASE_URL}sil/home/note/update`;
export const URL_SIL_ACCOMMODATION_CASE_NOTE_DELETE = `${BASE_URL}sil/home/note/delete`;
export const URL_SIL_ACCOMMODATION_CASE_NOTE_ATTACHMENT_DELETE = `${BASE_URL}sil/home/note/attachment`;

//Sil Documents
export const URL_SIL_ACCOMMODATION_DOCUMENT_FOLDER_LIST = `${BASE_URL}sil/home/document/show`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_FOLDER_CREATE = `${BASE_URL}sil/home/document/store`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_FOLDER_UPDATE = `${BASE_URL}sil/home/document/update`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_FILE_UPLOAD = `${BASE_URL}sil/home/document/upload-document`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_VIEW_FILE = `${BASE_URL}sil/home/document/view-file`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_FILE_REMOVE = `${BASE_URL}sil/home/document/delete-file`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_FOLDER_REMOVE = `${BASE_URL}sil/home/document/delete`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_FOLDER_MOVE = `${BASE_URL}sil/home/document/move`;
export const URL_SIL_ACCOMMODATION_DOCUMENT_FILE_UPDATE = `${BASE_URL}sil/home/document/update-document/`;

//Rostering Funding
export const URL_ROSTERING_LINKED_FUNDING_GET_NDIS_PRICE_CATALOG = `${BASE_URL}cos/service-support-budget/service-list`

//List of PUBLIC Holidays
export const URL_PUBLIC_HOLIDAY_LIST = `${BASE_URL}sp/public-holiday-list`;
export const URL_SERVICE_TYPES = `${BASE_URL}default-service-types`;
export const URL_PAYROLL_ACCOUNT_TYPES = `${BASE_URL}sp/payroll/get-account-types`;
export const URL_WORKER_SP_LIST = `${BASE_URL}worker/sp-list`;
export const URL_WORKER_DETAILS = `${BASE_URL}worker/details`;

// Incident Management URLs
export const URL_INCIDENT_LIST = `${BASE_URL}sp/incidents`;
export const URL_INCIDENT_CREATE = `${BASE_URL}sp/incidents/store`;
export const URL_INCIDENT_DETAIL = `${BASE_URL}sp/incidents/detail`;
export const URL_INCIDENT_PDF = `${BASE_URL}sp/incidents`;
export const URL_INCIDENT_UPDATE = `${BASE_URL}sp/incidents/update`;
export const URL_INCIDENT_DASHBOARD = `${BASE_URL}sp/incidents/dashboard`;
export const URL_INCIDENT_INVESTIGATE = `${BASE_URL}sp/incidents/investigate`;
export const URL_INCIDENT_CLOSE = `${BASE_URL}sp/incidents/close`;
export const URL_INCIDENT_CLOSE_DRAFT = `${BASE_URL}sp/incidents/close-draft`;
export const URL_INCIDENT_EXPORT = `${BASE_URL}sp/incidents/export`;
export const URL_INCIDENT_UPLOAD = `${BASE_URL}sp/incidents/upload`;
export const URL_INCIDENT_DELETE = `${BASE_URL}sp/incidents/delete`;
export const URL_INCIDENT_WORKER_LIST = `${BASE_URL}hrm/incidents`;
export const URL_INCIDENT_WORKER_DASHBOARD = `${BASE_URL}hrm/incidents/dashboard`;
export const URL_INCIDENT_WORKER_DETAIL = `${BASE_URL}hrm/incidents/detail`;
export const URL_INCIDENT_WORKER_PDF = `${BASE_URL}hrm/incidents`;
export const URL_INCIDENT_WORKER_CREATE = `${BASE_URL}hrm/incidents/store`;
export const URL_INCIDENT_WORKER_UPDATE = `${BASE_URL}hrm/incidents/update`;
export const URL_INCIDENT_WORKER_DELETE = `${BASE_URL}hrm/incidents/delete`;
export const URL_INCIDENT_TIMESHEETS = `${BASE_URL}sp/incidents/timesheets`;
export const URL_INCIDENT_WORKER_TIMESHEETS = `${BASE_URL}hrm/incidents/timesheets`;

// Audit Log
export const URL_AUDIT_LOG = `${BASE_URL}sp/audit-log`;
export const URL_AUDIT_LOG_EXPORT = `${BASE_URL}sp/audit-log/export`;
export const URL_AUDIT_LOG_ENTITY_TYPES = `${BASE_URL}sp/audit-log/entity-types`;
export const URL_AUDIT_LOG_NEW_COUNT = `${BASE_URL}sp/audit-log/new-count`;
export const URL_AUDIT_LOG_ACTIVITY = (id) => `${BASE_URL}sp/audit-log/activity/${id}`;

export const URL_SP_SERVICE_AGREEMENT_TEMPLATE = `${BASE_URL}sp/service-agreement-template`;
export const URL_SP_SERVICE_AGREEMENT_TEMPLATE_AVAILABLE_FIELDS = `${BASE_URL}sp/service-agreement-template/available-fields`;
export const URL_SP_SERVICE_AGREEMENT_TEMPLATE_PREVIEW = `${BASE_URL}sp/service-agreement-template/preview`;

// ---------------------------------------------------------------------------
// AI feature URLs
// Laravel (wallet, usage, billing) — same BASE_URL as the rest of the portal.
// Used by Settings → AI Credits & Usage; does not run inference.
// ---------------------------------------------------------------------------
export const URL_SP_AI_WALLET = `${BASE_URL}sp/ai/wallet`;
export const URL_SP_AI_TOP_UP = `${BASE_URL}sp/ai/top-up`;
export const URL_SP_AI_TOP_UP_STATUS = `${BASE_URL}sp/ai/top-up/status`;
export const URL_SP_AI_SUMMARY = `${BASE_URL}sp/ai/summary`;
export const URL_SP_AI_USAGE = `${BASE_URL}sp/ai/usage`;
export const URL_SP_AI_USAGE_FILTERS = `${BASE_URL}sp/ai/usage/filters`;
export const URL_SP_AI_USAGE_BY_FEATURE = `${BASE_URL}sp/ai/usage/by-feature`;
export const URL_SP_AI_USAGE_COST_SERIES = `${BASE_URL}sp/ai/usage/cost-series`;
export const URL_SP_AI_BULK_ANALYSE = `${BASE_URL}sp/ai/bulk-timesheet-analyse`;
export const URL_SP_AI_BULK_ANALYSE_PREVIEW = `${BASE_URL}sp/ai/bulk-timesheet-analyse/preview`;
export const URL_SP_AI_BULK_ANALYSE_ACTIVE = `${BASE_URL}sp/ai/bulk-timesheet-analyse/active`;
export const URL_SP_AI_BULK_ANALYSE_RUN = (uuid) =>
  `${BASE_URL}sp/ai/bulk-timesheet-analyse/${uuid}`;
export const URL_SP_AI_BULK_ANALYSE_STOP = (uuid) =>
  `${BASE_URL}sp/ai/bulk-timesheet-analyse/${uuid}/stop`;
export const URL_SP_AI_BULK_ANALYSE_RETRY = (uuid) =>
  `${BASE_URL}sp/ai/bulk-timesheet-analyse/${uuid}/retry`;
export const URL_SP_AI_BULK_ANALYSE_DISMISS = (uuid) =>
  `${BASE_URL}sp/ai/bulk-timesheet-analyse/${uuid}/dismiss`;
export const URL_SP_AI_SETTINGS = `${BASE_URL}sp/ai/settings`;
export const URL_SP_AI_SETTINGS_UPDATE = `${BASE_URL}sp/ai/settings/update`;
export const URL_SP_AI_ENABLEMENT_NOTICE_DISMISS = `${BASE_URL}sp/ai/enablement-notice/dismiss`;


// Vertex360 Copilot conversation CRUD + history (Laravel-owned; via apiCall).
export const URL_SP_AI_VERTEX360_COPILOT_CONVERSATIONS = `${BASE_URL}sp/ai/vertex360-copilot/conversations`;
export const URL_SP_AI_VERTEX360_COPILOT_CONVERSATIONS_STARRED = `${URL_SP_AI_VERTEX360_COPILOT_CONVERSATIONS}/starred`;
export const URL_SP_AI_VERTEX360_COPILOT_CONVERSATIONS_RECENT = `${URL_SP_AI_VERTEX360_COPILOT_CONVERSATIONS}/recent`;
export const URL_SP_AI_VERTEX360_COPILOT_CONVERSATIONS_BULK_DELETE = `${URL_SP_AI_VERTEX360_COPILOT_CONVERSATIONS}/bulk-delete`;
export const URL_SP_AI_VERTEX360_COPILOT_CONVERSATION = (uuid) =>
  `${BASE_URL}sp/ai/vertex360-copilot/conversations/${uuid}`;
export const URL_SP_AI_VERTEX360_COPILOT_MESSAGES = (uuid) =>
  `${BASE_URL}sp/ai/vertex360-copilot/conversations/${uuid}/messages`;

// Vertex360 AI service (Python) — direct from web; Bearer + sp_id / X-SP-ID.
// Base URL: REACT_APP_AI_SERVICE_URL (see aiClient.js, ai.services.js).
// Keep trailing slash (same pattern as BASE_URL) so path segments concatenate correctly.

export const URL_AI_TIMESHEET_ANOMALY_CHECK_BATCH = `${AI_SERVICE_URL}timesheets/anomaly-check`;

export const URL_AI_TIMESHEET_ANOMALY_CHECK_BATCH_STREAM = `${AI_SERVICE_URL}timesheets/anomaly-check/stream`;

export const URL_AI_VERTEX360_COPILOT_CHAT_STREAM = `${AI_SERVICE_URL}vertex360-copilot/chat/stream`;
export const URL_AI_VERTEX360_COPILOT_FEEDBACK = `${AI_SERVICE_URL}vertex360-copilot/feedback`;

export const URL_AI_VERTEX360_COPILOT_HISTORY = `${AI_SERVICE_URL}vertex360-copilot/conversations`;

export const URL_CARE_WATCH_SIGNALS = `${BASE_URL}sp/care-watch/signals`;
// KPI tiles. Same filters as the listing, so the two always agree.
export const URL_CARE_WATCH_OVERVIEW = `${BASE_URL}sp/care-watch/overview`;
// One signal, so the incident form can rebuild its prefill from a URL param.
export const URL_CARE_WATCH_SIGNAL = `${BASE_URL}sp/care-watch/signals`;
export const URL_CARE_WATCH_ACKNOWLEDGE = `${BASE_URL}sp/care-watch/signals/acknowledge`;
export const URL_CARE_WATCH_RISK = `${BASE_URL}sp/care-watch/signals/risk`;
export const URL_CARE_WATCH_PROMOTE = `${BASE_URL}sp/care-watch/signals/promote`;
export const URL_CARE_WATCH_LIVE = `${BASE_URL}sp/care-watch/live`;
export const URL_CARE_WATCH_LIVE_OVERVIEW = `${BASE_URL}sp/care-watch/live/overview`;

// End AI feature URLs — add new inference endpoints above this line.